import type { ReactNode } from 'react';

export interface ActionButton {
  label: string;
  onClick: () => void;
  variant?: 'contained' | 'outlined' | 'text';
  color?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'success'
    | 'warning'
    | 'info'
    | 'inherit';
  disabled?: boolean;
  loading?: boolean;
  startIcon?: ReactNode;
  tooltip?: string;
}

export interface ToggleTab {
  id: string;
  label: string;
  value: string;
}

export interface ActionChip {
  id: string;
  label: string;
  onClick: () => void;
  variant?: 'filled' | 'outlined';
  color?: 'primary' | 'secondary' | 'error' | 'success';
}

export type PageHeaderVariant =
  | 'pageHeader'
  | 'subHeader'
  | 'dialogHeader'
  | 'dialog';

export const PAGE_HEADER_PADDING: Record<PageHeaderVariant, string> = {
  pageHeader: '24px 0px 24px',
  subHeader: '0px 0px 10px',
  dialogHeader: '8px 0px',
  dialog: '12px 20px 0px',
};
